// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__3aDi9","expandIcon":"AccordionButton_expandIcon__2YcVm","expanded":"AccordionButton_expanded__pA2dP"};